import { render, staticRenderFns } from "./SingleArticle.vue?vue&type=template&id=75eb5cd7&scoped=true&"
import script from "./SingleArticle.vue?vue&type=script&lang=js&"
export * from "./SingleArticle.vue?vue&type=script&lang=js&"
import style0 from "./SingleArticle.vue?vue&type=style&index=0&id=75eb5cd7&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75eb5cd7",
  null
  
)

export default component.exports